<template>
    <div class="popup popup-routeDetail" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  id="routeDetail">
        <div class="routeDetail-t js-returnDetailBtn">
            <a class="routeDetail-returnButton" @click="goBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
            <p class="routeDetail-t-title">行程</p>
        </div>
        <div class="routeDetail">
            <div class="routeDetail-title">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/routeAnchorIconB.png">
                <span>参考行程</span>
            </div>
            <div class="routeDetail-container scroll-container">

                <div class="routeDetail-item" v-for="(routeEvent, i) in routeEvents" :key="i">
                    <p class="routeDetail-itemTitle">
                        <strong>第{{routeEvent.day}}天</strong>&nbsp;<strong>
                            {{routeEvent.portDay}}
                        </strong> {{getTitle(routeEvent)}}
                    </p>
                    <div class="routeDetail-itemDescrib">
                        <div class="routeDetail-itemDescrib-txt routeDetail-itemDescrib-content">
                            <div class="routeDetailImages">
                                <Swiper class="routeDetailSwiper" :ref="('routeDetailSwiper' + i)" :options="swiperOptions[i]"
                                @slideChangeTransitionEnd="onImageChangeTransitionEnd(i)">
                                    <SwiperSlide v-for="(image, j) in routeEvent.images" :key="('image' + j)"
                                    class="routeDetail-image" style="width: 335px;"
                                    >
                                        <img v-lazy="image">
                                    </SwiperSlide>
                                </Swiper>
                                <div class="routeSwiperOrder"><span>{{imageIndexes[i]}}</span>/{{routeEvent.images.length}}</div>
                            </div>

                            <div v-html="getDescription(routeEvent)">
                            </div>
                            <template v-if="showRow == false">
                            <div class="routeDetail-itemShorex" v-if="routeEvent.activity == 'DOCKED'">
                                <div class="js-shorexDetailBtn" @click="showShorexPopup(routeEvent.name)"><span class="shorex_but">岸上观光服务 &gt;</span></div>
                            </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="packageDetail-routeDetail js-returnRouteBtn close-popup" style="display:none;">
            <span>返回航线详情页</span>
        </div>
    </div>
</template>

<script>
import { directive, Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: "RouteInfoPopup",
    components: {
        Swiper,
        SwiperSlide
    },
     directives: {
        swiper: directive
    },
    props: {
        onGoBack: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        routeEvents: {
            type: Array,
            default () {
                return []
            }
        },
        shipCode: {
            type: String
        },
        showShorexPopup: {
            type: Function
        },
        showRow: {
            type: Boolean,
            default () {
                return false
            }
        },
    },
    data () {
        return {
            swiperOptions: [],
            imageIndexes: []
        }
    },
    beforeMount () {
        this.initPage()
    },
    methods: {
        initPage () {
            this.imageIndexes = []
            this.swiperOptions = []
            for (let i = 0; i < this.routeEvents.length; i++) {
                this.$set(this.imageIndexes, i, 1)
                //this.imageIndexes.push(1)
                this.swiperOptions.push({
                })
            }
        },
        goBack () {
            this.onGoBack()
        },
        getTitle (routeEvent) {
            const code = routeEvent.code
            if (code && code.indexOf("CRU") >= 0) {
                return "巡航"
            }
            let title = routeEvent.countryName
            if (routeEvent.activity == "EMBARK" || routeEvent.activity == "DEBARK") {
              title += "·" + routeEvent.harborCNName
            } else {
                title += "·" + routeEvent.name
            }
            let arrivalTime = routeEvent.arrivalTime
            if (arrivalTime && arrivalTime.length > 0) {
                if (arrivalTime.length > 5) {
                    arrivalTime = arrivalTime.substring(0, 5)
                }
                title += "  抵港 " + arrivalTime
            }

            let departureTime = routeEvent.departureTime
            if (departureTime && departureTime.length > 0) {
                if (departureTime.length > 5) {
                    departureTime = departureTime.substring(0, 5)
                }
                title += "  起航 " + departureTime
            }

            return title

        },
        getDescription (routeEvent) {
            let description = routeEvent.description
            // let link = ""
            if (routeEvent.activity == "EMBARK" || routeEvent.activity == "DEBARK") {
                // if (routeEvent.code.indexOf('HKG') == 0) {
                //     link = "https://resource.rcclchina.com.cn/PDF/%E7%9A%87%E5%AE%B6%E9%81%8A%E8%BC%AA%E5%81%87%E6%9C%9F-%E6%B5%B7%E6%B4%8B%E5%85%89%E8%AD%9C%E8%99%9F%E9%A6%99%E6%B8%AF%E8%88%AA%E6%AC%A1%20%EF%BC%88CH%20%20EN%EF%BC%89-1.pdf"
                // }
                // else if (this.shipCode == 'SC') {
                //     link = "https://www.rcclchina.com.cn/media/default/images/Royal_Cruise_Vacation-SC.pdf"
                // } else if (this.shipCode == 'QN') {
                //     link = "https://www.rcclchina.com.cn/media/default/images/Royal_Cruise_Vacation-QN.pdf"
                // }
                // if (link.length > 0) {
                //     description += `<p>
                //         <span>您可能还需要了解：<a href='${link}' target='_blank'>行前准备和登船离船</a></span>
                //     </p>`
                // }
            }
            return description
        },
        onImageChangeTransitionEnd(routeIndex) {
            const swiper = this.$refs['routeDetailSwiper' + routeIndex][0]
            const index = swiper.swiperInstance.activeIndex
            this.$set(this.imageIndexes, routeIndex, index + 1)
            // this.imageIndexes[routeIndex] = index + 1
        },
        onShorexClick(cityName, seaDay) {
            this.showShorexPopup(cityName, seaDay)
        }
    },
    watch:  {
        routeEvents () {
            this.initPage()
        }
    }
}
</script>

<style lang="less">
.routeDetail-itemDescrib-txt {
    p, span{
        
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        line-height: 18px;
    }
    a {
        
        font-size: 12px;
        color: #0073bb
    }
}
</style>

<style lang="less" scoped>
#routeDetail.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
}
#routeDetail.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#routeDetail.modal-out {
    transform: translate3d(100%, 0, 0);
}

#routeDetail {
    overflow-y: hidden;
    padding-bottom: 50px;
    .routeDetail-t {
        position: absolute;
        width: 100%;
        text-align: center;
        height: 50px;
        line-height: 50px;
        background-color: #fff;
        z-index: 10;
        .routeDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 4px;
            left: 20px;
            text-align: left;
            img {
                width: 33%;
            }
        }
        .routeDetail-t-title {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            margin: 0;
        }
    }
    .routeDetail {
        height: 100%;
        overflow-y: auto;
        margin-top: 44px;
        padding: 16px 20px;
        background-color: #fff;
        .routeDetail-title {
            img {
                width: 15px;
                vertical-align: middle;
            }
            span {
                display: inline-block;
                vertical-align: middle;
                
                font-size: 14px;
                color: #333333;
                letter-spacing: 0;
            }
        }
        .routeDetail-container {
            .routeDetail-item {
                padding: 18px 0;
                border-bottom: 1px solid #ccc;
                .routeDetail-itemTitle {
                    
                    font-size: 14px;
                    color: #151515;
                    letter-spacing: 1px;
                    margin: 0;
                }
                .routeDetail-itemDescrib {
                    overflow: hidden;
                    padding-top: 12px;
                    position: relative;
                    .routeDetail-itemDescrib-txt {
                        display: inline-block;
                        float: left;
                        
                        font-size: 12px;
                        color: #666666;
                        letter-spacing: 0;
                        line-height: 18px;
                        width: 100%;
                        position: relative;
                        .routeDetailImages {
                            position: relative;
                            .routeSwiperOrder {
                                position: absolute;
                                bottom: 9px;
                                left: 18px;
                                width: 38px;
                                text-align: center;
                                height: 16px;
                                line-height: 15px;
                                background: rgba(0,0,0,0.4);
                                border-radius: 8px;
                                
                                font-size: 12px;
                                color: #FFFFFF;
                                letter-spacing: 1px;
                                z-index: 2;
                                display: block;
                                transform: translate3d(0px, 0px, 0px);
                                span {
                                    color: #ffffff;
                                }
                            }
                        }
                        .routeDetailSwiper {
                            margin-bottom: 20px;
                            .routeDetail-image {
                                // width: 287px;
                                max-height: 295px;
                                overflow: hidden;
                                img {
                                    width: 100%;
                                }
                            }

                        }
                        p, a, span {
                            
                        }
                        .routeDetail-itemShorex > div {
                            float: left;
                            height: 18.2px;
                            border-bottom: 1px solid #4A90E2;
                            span {
                                
                                font-size: 11px;
                                color: #4A90E2;
                                letter-spacing: 0.785px;
                            }
                        }

                    }
                    .routeDetail-itemDescrib-content {
                        position: relative;
                    }
                }
                .routeDetail-itemDescrib:last-child:before {
                    content: '';
                    position: absolute;
                    top: 2px;
                    left: 9px;
                    height: 8px;
                    width: 1px;
                    border-left: 1px dotted #4A90E2;
                    opacity: .2;
                    filter: alpha(opacity=20);
                }
            }
        }
    }
}
</style>
